import { ReactNode } from 'react';
import { ConfigProvider as AntConfigProvider } from 'antd';

export type ConfigProviderProps = {
  children: ReactNode;
};

export const ConfigProvider = ({ children }: ConfigProviderProps) => (
  <AntConfigProvider
    theme={{
      components: {
        Menu: {
          dropdownWidth: 180, // default value of 160 not enough for header popup
        },
      },
      token: {
        colorPrimary: '#0068b5',
        colorLink: '#0068b5',
        fontFamily: `IntelOneText, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
      },
    }}
  >
    {children}
  </AntConfigProvider>
);
